import PropTypes from 'prop-types';

import { accountSummaryShape } from '../account';

const teamShape = PropTypes.shape({
  teamId: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  accountSummaries: PropTypes.arrayOf(accountSummaryShape),
  count: PropTypes.number,
});

const teamSummaryShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  subscriptionId: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
});

export {
  teamShape,
  teamSummaryShape,
};
